// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"14d341fb","173":"bd95896e","285":"23d04f43","412":"a0148466","488":"6a993e0e","557":"75ab873c","680":"0c0d9f23","741":"3bdfbbad","889":"7b5c52e9","947":"a23e19da"}[chunkId] + ".chunk.js";
};